import SharedAppointmentsManagement from "../../components/SharedAppointmentsManagement"

export default function SharedManagement() {
  return (
    <SharedAppointmentsManagement
      fetchOnlyActive={false}
    />
  )
};